import { getMarketOverviewBreadcrumbsRoute, getParentBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';

const getIssuerBreadcrumbs = (filters, parent, issuer) => ([
  getMarketOverviewBreadcrumbsRoute(filters, true),
  ...(parent ? [getParentBreadcrumbsRoute(parent)] : []),
  {
    title: issuer.name,
    isActive: true,
  },
]);

export default getIssuerBreadcrumbs;
